import { APIConfig, BaseAPIConfig, buildConfig, ConfigEnvironment, ConfigMap } from "@eres/api";

interface RestConfig {
	taqyimeeAPI: () => APIConfig;
	trakheesiCertAPI: () => APIConfig;
	classificationRankAPI: () => IRankingConfig;
}

const dev: RestConfig = {
	taqyimeeAPI: () => new BaseAPIConfig( "https", "devmobile.dubailand.gov.ae", "Taqyeem.Identity" ),
	trakheesiCertAPI: () => new BaseAPIConfig( "https", "devgate.dubailand.gov.ae", "trakheesi" ),
	classificationRankAPI: () => new ClassificationRankConfig( "https", "devgate.dubailand.gov.ae", "classification", "Fr8OqkOR0RvOyaL/bM0DUwMttTXV/ANLdPfLKYzoW3TsHm02dkFBLFRygM3+a8CS9PTo8d81CXxv01kLCF6bCxUygE6kCMiuvt2jybdHpVVJLwfgdCh14k5uWCM9w1y0MhUUN" +
		"BA5WsdZ1kY1CfclWi/eTZZ30WuYgknFuudGK6gUIoTNJt1lLimOGHeGJWqXeQNGp5jAlDEFAPNCfHmcvMcIUThJ2Y7rsSC4oiZOGVUfz1k65vApKmR9SN92w8dMajoIpEVx0V/uuMZHs0+XLutzORumrd0ZXPzRzfOE+Ik=", "api" )
};

const qa: RestConfig = {
	taqyimeeAPI: () => new BaseAPIConfig( "https", "stgapi.dubailand.gov.ae:8888", "Taqyeem" ),
	trakheesiCertAPI: () => new BaseAPIConfig( "https", "stgapi.dubailand.gov.ae:7443", "trakheesi" ),
	classificationRankAPI: () => new ClassificationRankConfig( "https", "stgapi.dubailand.gov.ae:8888", "RealEstateClassification.Server",
		"Fr8OqkOR0RvOyaL/bM0DUwMttTXV/ANLdPfLKYzoW3TsHm02dkFBLFRygM3+a8CS9PTo8d81CXxv01kLCF6bCxUygE6kCMiuvt2jybdHpVVJLwfgdCh14k5uWCM9w1y0MhUUN" +
		"BA5WsdZ1kY1CfclWi/eTZZ30WuYgknFuudGK6gUIoTNJt1lLimOGHeGJWqXeQNGp5jAlDEFAPNCfHmcvMcIUThJ2Y7rsSC4oiZOGVUfz1k65vApKmR9SN92w8dMajoIpEVx0V/uuMZHs0+XLutzORumrd0ZXPzRzfOE+Ik=", "api" )
};

const prod: RestConfig = {
	taqyimeeAPI: () => new BaseAPIConfig( "https", "mobile.dubailand.gov.ae", "Taqyimee" ),
	trakheesiCertAPI: () => new BaseAPIConfig( "https", "gateway.dubailand.gov.ae", "trakheesi" ),
	classificationRankAPI: () => new ClassificationRankConfig( "https", "gateway.dubailand.gov.ae", "classification", "Fr8OqkOR0RvOyaL/bM0DUwMttTXV/ANLdPfLKYzoW3TsHm02dkFBLFRygM3+a8CS9PTo8d81CXxv01kLCF6bCxUygE6kCMiuvt2jybdHpVVJLwfgdCh14k5uWCM9w1y0MhUUN" +
		"BA5WsdZ1kY1CfclWi/eTZZ30WuYgknFuudGK6gUIoTNJt1lLimOGHeGJWqXeQNGp5jAlDEFAPNCfHmcvMcIUThJ2Y7rsSC4oiZOGVUfz1k65vApKmR9SN92w8dMajoIpEVx0V/uuMZHs0+XLutzORumrd0ZXPzRzfOE+Ik=", "api" )
};

const configs: ConfigMap<RestConfig> = {
	dev: dev,
	qa: qa,
	production: prod,
};

export interface IRankingConfig extends APIConfig {
	token(): string;
}

export class ClassificationRankConfig extends BaseAPIConfig implements IRankingConfig {
	private _token;

	constructor( prot: string, server: string, app: string, token: string, api?: string ) {
		super( prot, server, app, api );
		this._token = token;
	}

	token(): string {
		return this._token;
	}
}

const cfg = buildConfig<RestConfig, ConfigEnvironment>( "dev", configs );
export default cfg;
